export default {
  statistics: {
    total_followers: 'Abonnés au total',
    emails_sent: 'E-mails envoyés',
    emails_opened: 'E-mails ouverts',
    emails_clicked: 'E-mails cliqués',
    emails_average_open_rate: "Taux d'ouverture des e-mails",
    emails_average_click_rate: 'Taux de clic des e-mails',
    push_notifications_sent: 'Notifications push envoyées',
    push_notifications_clicked: 'Notifications push cliquées',
  },
};
